export const listStatus = [
    {value: 'pending', name: 'Pending'},
    {value: 'in_production', name: 'In production'},
    {value: 'cancelled', name: 'Cancelled'},
    {value: 'on-hold', name: 'On hold'},
    {value: 'packaged', name: 'Packaged'},
    {value: 'labelled', name: 'Labelled'},
    {value: 'cancel-ship', name: 'Cancel ship'},
    {value: 'false_design', name: 'False design'},
    {value: 'manual-package', name: 'Manual Package'}
]

export const listPrint = [
    {value: 'created', name: 'Not printed'},
    {value: 'completed', name: 'Printed'}
]

export const listLocal = [
    {value: 'multrans_eu', name: 'Multrans EU'},
    {value: 'multrans_us', name: 'Multrans US'},
    {value: 'multrans_us_fast', name: 'Multrans DHL fast'},
    {value: 'royal_mail', name: 'Royal Mail'},
    {value: 'singapore_post', name: 'Singapore Post'},
    {value: 'shopee', name: 'Shopee'},
    {value: 'ghtk', name: 'Giao hàng tiết kiệm'},
    {value: 'vn_post', name: 'VN Post'},
    {value: 'shippo_us', name: 'Shippo US'},
    {value: 'vn', name: 'Việt Nam'},
    {value: 'timus', name: 'TimUS'},
    {value: 'ib_blue', name: 'IB Blue'},
    {value: 'ups_uk', name: 'UPS UK'},
    {value: 'usps_mn', name: 'USPS MN'},
    {value: 'hnc', name: 'Hợp Nhất (USPS)'},
    {value: 'bg_dhl', name: 'BG DHL'},
    {value: 'flashship_usps', name: 'LLC USPS'},
    {value: 'flashship_usps_manual', name: 'LLC_manual'},
    {value: 'us_express', name: 'US Express'},
    {value: 'dailydesign', name: 'Daily Design'},
    {value: 'dpd_uk', name: 'DPD UK'},
    {value: 'bs_us', name: 'BS US'},
    {value: 'bs_vn', name: 'BS VN'},
    {value: 'sb_ca', name: 'SB CA'},
    {value: 'sb_au', name: 'SB AU'},
    {value: 'SB_FAST', name: 'SB_FAST'},
    {value: 'teddy_4_life', name: 'Teddy 4 Life'},
    {value: 'sb_yun_express', name: 'SB-YUN'},
    {value: 'hw_usps', name: 'HW_USPS'},
    {value: 'hw_ups', name: 'HW_UPS'},
    {value: 'hw_gb', name: 'HW_GB'},
    {value: 'hw_tiktok', name: 'HW_TIKTOK'},
    {value: 'zone9_us', name: 'ZONE9_US'},
    {value: 'zone9_ca', name: 'ZONE9_CA'},
    {value: 'hw_yun', name: 'HW_YUN'},
    {value: 'hq', name: 'HQ'},
    {value: 'LB_USPS', name: 'LB_USPS'},
    {value: 'GC_LLC', name: 'GC_LLC'},
    {value: 'jt_usps', name: 'JT_USPS'},
    {value: 'ns_usps', name: 'NS_USPS'},
    {value: 'hw_tiktok', name: 'HW TIKTOK'},
    {value: 'hw_ttship', name: 'HW TTSHIP'},
    {value: 'hw_gb_ttship', name: 'HW GB TTSHIP'},
    {value: 'hw_tiktok_gb', name: 'GB HW TIKTOK'},
    {value: 'ge_dhl', name: 'ITC Standard'},
    {value: 'ge_tiktok', name: 'ITC TIKTOK'},
    {value: 'ge_ttship', name: 'ITC TTSHIP'},
    {value: 'itc_spx', name: 'ITC SPX'},
    {value: 'itc_gofo', name: 'ITC GOFO'},
    {value: 'kl_dhl', name: 'KL Standard'},
    {value: 'kl_ttship', name: 'KL TTSHIP'},
    {value: 'kl_usps', name: 'KL USPS'},
    {value: 'other', name: 'Other'},
]

export const listLineship = [
    {value: 'multrans_eu', name: 'EU'},
    {value: 'multrans_us_fastx', name: 'FAST'},
    {value: 'multrans_us', name: 'MainMT'},
    {value: 'multrans_us_fast', name: 'MainMT-fast'},
    {value: 'royal_mail', name: 'UK'},
    {value: 'singapore_post', name: 'MainMT'},
    {value: 'shopee', name: 'Shopee'},
    {value: 'ghtk', name: 'GHTK'},
    {value: 'shippo_us', name: '1CDH'},
    {value: 'timus', name: '1CUS'},
    {value: 'ib_blue', name: 'IBUS'},
    {value: 'ups_uk', name: 'UPSUK'},
    {value: 'usps_mn', name: 'USPS-MN'},
    {value: 'hnc', name: 'HNC-USPS'},
    {value: 'bg_dhl', name: 'BG-DHL'},
    {value: 'flashship_usps', name: 'LLC-USPS'},
    {value: 'flashship_usps_manual', name: 'LLC-USPS'},
    {value: 'dailydesign', name: 'Daily-Design'},
    {value: 'dpd_uk', name: 'DPD-UK'},
    {value: 'bs_us', name: 'BS-US'},
    {value: 'bs_vn', name: 'BS VN'},
    {value: 'sb_ca', name: 'SB CA'},
    {value: 'sb_au', name: 'SB AU'},
    {value: 'SB_FAST', name: 'SB_FAST'},
    {value: 'teddy_4_life', name: 'Teddy 4 Life'},
    {value: 'us_express', name: 'US Express'},
    {value: 'sb_yun_express', name: 'SB-YUN'},
    {value: 'hw_usps', name: 'HW_USPS'},
    {value: 'hw_ups', name: 'HW_UPS'},
    {value: 'hw_gb', name: 'HW_GB'},
    {value: 'hw_tiktok', name: 'HW_TIKTOK'},
    {value: 'zone9_us', name: 'ZONE9_US'},
    {value: 'zone9_ca', name: 'ZONE9_CA'},
    {value: 'LB_USPS', name: 'LB_USPS'},
    {value: 'GC_LLC', name: 'GC_LLC'},
    {value: 'vn', name: 'VN'},
    {value: 'usps_mn_ib_blue', name: 'USPS-IB'},
    {value: 'ib_blue_usps_mn', name: 'IB-USPS'},
    {value: 'hw_yun', name: "HW_YUN"},
    {value: 'hq', name: "HQ"},
    {value: 'jt_usps', name: "JT_USPS"},
    {value: 'ns_usps', name: "NS_USPS"},
    {value: 'hw_tiktok', name: 'HW TIKTOK'},
    {value: 'hw_ttship', name: 'HW TTSHIP'},
    {value: 'hw_gb_ttship', name: 'HW GB TTSHIP'},
    {value: 'ge_dhl', name: 'ITC Standard'},
    {value: 'ge_tiktok', name: 'ITC TIKTOK'},
    {value: 'hw_tiktok_gb', name: 'GB HW TIKTOK'},
    {value: 'ge_ttship', name: 'ITC TTSHIP'},
    {value: 'itc_spx', name: 'ITC SPX'},
    {value: 'itc_gofo', name: 'ITC GOFO'},
    {value: 'kl_dhl', name: 'KL Standard'},
    {value: 'kl_ttship', name: 'KL TTSHIP'},
    {value: 'kl_usps', name: 'KL USPS'},

]

export const listLabel = [
    {name: 'Not Generate', value: 'created'},
    {name: 'Generated', value: 'generated'},
    {name: 'Regenerated', value: 'regenerated'},
    {name: 'Error', value: 'error'},
    {name: 'Waiting', value: 'waiting'},
]

export const listGenerate = [
    {name: 'Default', value: 'default'},
    {name: 'ASAP', value: 'after_pushed'},
    {name: 'Packaging stage', value: 'after_produced'},
    {name: 'Custom day', value: 'days'},
]

export const listOverTime = [
    {name: 'Orders vượt quá thời gian cam kết', value: 'y'},
    {name: 'Orders không vượt quá thời gian cam kết', value: 'n'},
    {name: 'Số ngày quá hạn', value: 'time'},
    {name: 'Số ngày sắp quá hạn', value: 'remaining_time'},
    {name: 'Orders quá hạn gen label', value: 'products.delayedGenLabel'},
]

export const LIMIT = [
    {name: '50 rows', value: 50},
    {name: '100 rows', value: 100},
    {name: '150 rows', value: 150},
    {name: '200 rows', value: 200},
    {name: '500 rows', value: 500},
]

export const shippingPlan = [
    {name: 'Fast shipping', value: 'fast'},
]

export const optionNote = [
    {name: 'Yes', value: 'y'},
    {name: 'No', value: 'n'},
]

export const REQUEST_UPDATE_ORDER = [
    {name: 'Waiting update', value: 'waiting-update-design'},
    {name: 'Waiting update address', value: 'waiting-update-address'},
    {name: 'Updated', value: 'updated'},
    {name: 'No request', value: 'no-request'}
]

export const LIST_SOURCE = [
    {name: 'API', value: 'api'},
    {name: 'IMPORT', value: 'import'}
]

export const optionOrderType = [
    {name: 'FBA', value: 'y'},
    {name: 'Normal', value: 'n'},
    {name: 'TikTok', value: 'TikTok'},
]

export const listTrackingStatus = [
    {
        name: 'All',
        value: ''
    },
    {
        name: 'Unknown',
        value: 'unknown'
    },
    {
        name: 'Pre_transit',
        value: 'pre_transit'
    },
    {
        name: 'In_transit',
        value: 'in_transit'
    },
    {
        name: 'Out for delivery',
        value: 'out_for_delivery'
    },
    {
        name: 'Delivered',
        value: 'delivered'
    },
    {
        name: 'Exception',
        value: 'exception'
    },
]
export const shippingLevels = [
    {
        name: 'Ship nhanh',
        value: '60'
    },
]

export const listShippingLevel = [
    {
        name: 'Select shipping level',
        value: ''
    },
    {
        name: 'First Class',
        value: '50'
    },
    {
        name: 'Priority',
        value: '60'
    }
]

export const listTags = [
    {
        name: 'FBA',
        value: 'fba'
    },
    {
        name: 'Gift',
        value: 'gift'
    },
    {
        name: 'Sample',
        value: 'sample'
    },
    {
        name: 'Fastship',
        value: 'fastship'
    },
    {
        name: 'Priority Store',
        value: 'priority-store'
    },
    {
        name: 'MT_US_NHE',
        value: 'MT_US_NHE'
    },
    {
        name: 'HW_NANG',
        value: 'HW_NANG'
    },
    {
        name: 'Fastproduction',
        value: 'fastproduction'
    },
    {
        name: 'Cutoff',
        value: 'cutoff'
    },
    {
        name: 'Cutoff noel',
        value: 'cutoff_noel'
    },
    {
        name: 'Cutoff new year',
        value: 'cutoff_new_year'
    },
    {
        name: 'VT Tracking',
        value: 'VT_tracking'
    },
    {
        name: 'tiktok',
        value: 'tiktok'
    }
]

export const optionsError2D = [
    {name: 'Yes', value: 'yes'},
    {name: 'No', value: 'no'},
]

export const optionsHoldShip = [
    {name: 'Yes', value: 'y'},
    {name: 'No', value: 'n'},
]

export const optionsCombineShip = [
    {name: 'Yes', value: 'y'},
    {name: 'No', value: 'n'},
]

export const listWarningShip = [
    {
        name: 'Đã hoàn thành',
        value: 'completed'
    },
    {
        name: 'Đã dán label',
        value: 'labelled'
    }
]

export const listPartner = [
    // { value: 'BINHMINH', name: 'Bình Minh' },
    // { value: 'QUANGMINH', name: 'Quang Minh' },
    { value: 'MCLAB', name: 'MC Lab' },
    { value: 'VIP', name: 'VIP' },
    { value: 'NOTVIP', name: 'NOT VIP' },
    // { value: 'DECAL', name: 'DECAL' },
]

export const listErrorProcessQuality = [
    {value: "print", name: "Lỗi in"},
    {value: "fabric", name: "Lỗi vải"},
    {value: "cut", name: "Lỗi cắt"},
    {value: "billet", name: "Lỗi phôi"},
    {value: "improve", name: "Lỗi hoàn thiện"},
    {value: "engrave", name: "Lỗi khắc"},
    {value: "other", name: "Lỗi khác"},
    {value: "all", name: "Tất cả"}
]

export const listErrorCustomerService = [
    {value: "manufacturing_error", name: "Lỗi may/ gia công"},
    {value: "wrong_item", name: "Sai hàng"},
    {value: "defective_item", name: "Sản phẩm lỗi"},
    {value: "fabric_blank_material_error", name: "Lỗi vải/phôi/NVL"},
    {value: "color_mismatch_in_print", name: "Lệch màu in"},
    {value: "design_error", name: "Lỗi design"},
    {value: "blurry_print", name: "Hình in mờ"},
    {value: "size_chart", name: "Size chart"},
    {value: "missing_item", name: "Thiếu hàng"},
    {value: "print_area_too_small_misaligned_print_area", name: "Vùng in to bé - lệch vùng in"},
    {value: "other", name: "Lỗi khác"},
    {value: "all", name: "Tất cả"}
]